import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import MainHeading from '@/components/common/MainHeading';
import Layout from '@/components/Layout/Layout';
import SendNotificationModal from '@/components/Modal/SendNotificationModal';
import { INotification } from '@/interfaces/common.model';
import { timeAgo } from '@/utility/CommonFunctions';
import { getNotificationUrl, showToastNotification } from '@/utility/helper';
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from 'reactstrap';

export interface INotificationRespone {
  status: boolean;
  data: { notification: INotification[] | null };
}

const Notification = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [pageNo, setPageNo] = useState<number>(1);
  const [notificationData, setNotificationData] = useState<INotification[]>([]);

  const getNotificationData = useCallback(async (pageNo: number) => {
    try {
      setIsLoading(true);
      const API =
        API_URL +
        API_ENDPOINT?.getNotification +
        `?pageNumber=${pageNo}&pageSize=10`;
      const response: INotificationRespone = await callApi(API, {
        method: 'GET',
      });
      setIsLoading(false);
      if (response?.status) {
        console.log(response?.data?.notification);
        const newNotifications = (response?.data?.notification || []).map(
          (n) => ({
            ...n,
            data: typeof n.data === 'string' ? JSON.parse(n.data) : n.data,
          }),
        );
        if (newNotifications.length > 0) {
          setNotificationData(newNotifications);
        } else {
          setHasMore(false);
        }
      } else {
        setHasMore(false);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (hasMore) {
      getNotificationData(pageNo);
    }
  }, [pageNo, getNotificationData, hasMore]);
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 1 &&
        !isLoading &&
        hasMore
      ) {
        setPageNo((prevPageNo) => prevPageNo + 1);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isLoading, hasMore]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title="Notification"
            isNotification={true}
            buttonText="Send Notification"
            clickHandler={toggle}
          />
          <div className="card mb-4">
            <div className="card-body mb-4 mb-xl-0">
              {notificationData && notificationData.length > 0
                ? notificationData.map((item, index) => (
                  <div
                    key={index}
                    className="p-2 pb-4 mb-4 font-13 border-bottom"
                  >
                    <Link
                      to={getNotificationUrl(item)}
                      className="text-decoration-none text-black"
                    >
                      <div
                        className=" d-flex flex-column gap-2"
                      // onClick={() => handleNavigateTabs(item)}
                      >
                        <>
                          <div className="d-flex justify-content-between">
                            <h4
                              className="m-0 lead fw-semibold"
                              style={{ fontSize: '14px' }}
                            >
                              {item?.data?.title}
                            </h4>
                            <span className="text-muted fs-6">
                              {timeAgo(item?.createdAt)}
                            </span>
                          </div>

                          <p className="text-wrap fs-5 mb-0 lead ">
                            {item?.message}
                          </p>
                        </>
                      </div>
                    </Link>
                  </div>
                ))
                : !isLoading && (
                  <div className="d-flex justify-content-center font-14 text-muted p-3">
                    No Notifications
                  </div>
                )}
              {isLoading && (
                <div className="d-flex justify-content-center my-4">
                  <Spinner color="primary" />
                  {/* <Spinner color="primary" type="grow" />
                  <Spinner color="primary" type="grow" />
                  <Spinner color="primary" type="grow" />
                  <Spinner color="primary" type="grow" /> */}
                </div>
              )}
              {!hasMore && !isLoading && notificationData.length > 0 && (
                <p className="text-center m-0 text-muted p-0 fs-5 lead">
                  No more notifications
                </p>
              )}
            </div>
          </div>
        </div>
      </Layout>
      <SendNotificationModal closeHandler={toggle} isOpen={isOpen} />
    </>
  );
};

export default Notification;
